/** Arte dos plugues (line-art em perspectiva) — CCS2 para DC, Type 2 para AC.
 *
 * Substitui o `CCS2Icon` genérico nos tamanhos grandes (34–64px). Dois ganhos:
 * a arte é a do desenho aprovado pelo operador, e o ícone passa a ser
 * CORRETO POR TIPO — o antigo desenhava CCS2 mesmo num conector Type 2, o
 * mesmo bug que já tinha sido corrigido no `ConnectorGlyph` em jul/2026.
 *
 * Os PNGs são máscaras de alfa puro (traço no canal alpha, RGB branco), então
 * a cor vem de `background-color` via `mask-image`. É o que preserva o
 * contrato do componente antigo: quem chamava passando `color` continua
 * funcionando, inclusive em fundo escuro. Um `<img>` comum não daria isso —
 * PNG preto não se recolore.
 *
 * `mask-image` exige iOS 15.4+; o app já pede 15.5 desde a release 1.2.0
 * (plugin do scanner), então não há shell mais antigo em campo.
 *
 * NÃO usar nos glifos pequenos (11–19px do `ConnectorGlyph`): nesses tamanhos
 * o desenho em perspectiva vira borrão — comparação feita em 2026-08-23.
 */

/** Arte disponível por tipo. Tipo sem arte cai no `ConnectorGlyph` (caller). */
const ART: Record<string, string> = {
  CCS2: '/connectors/ccs2.png',
  Type2: '/connectors/type2.png'
};

export function connectorArtSrc(type: string | null | undefined): string | null {
  return ART[(type ?? '').trim()] ?? null;
}

export function ConnectorArt({
  type,
  size = 64,
  color = '#001B74'
}: {
  type: string;
  size?: number;
  color?: string;
}) {
  const src = connectorArtSrc(type) ?? ART.CCS2;
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        backgroundColor: color,
        WebkitMaskImage: `url("${src}")`,
        maskImage: `url("${src}")`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center'
      }}
    />
  );
}
